export default __webpack_public_path__ + "static/media/popup.997fe44f.svg";